module.exports = __webpack_public_path__ + "6452543f0b5b9a4e1876cdc18a59d179.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=2400!./src/components/cover/teaser.jpg?size=2400w
// module id = 36
// module chunks = 1